import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeletePortfolioPage($companyId: ID!, $id: ID!) {
    deletePortfolioPage(companyId: $companyId, id: $id) {
      portfolioPage {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
